// extracted by mini-css-extract-plugin
export var articleColumn = "footer-module--article-column--7370a";
export var author = "footer-module--author--3ebaf";
export var bottomBar = "footer-module--bottom-bar--49ec8";
export var bottomLogo = "footer-module--bottom-logo--f3fb8";
export var brandColumn = "footer-module--brand-column--4353d";
export var brandHeadline = "footer-module--brand-headline--96827";
export var category = "footer-module--category--edc0d";
export var columnTitle = "footer-module--column-title--196a7";
export var columns = "footer-module--columns--53f24";
export var copyright = "footer-module--copyright--65e65";
export var euFunding = "footer-module--eu-funding--b0d21";
export var footer = "footer-module--footer--74815";
export var headline = "footer-module--headline--d69ba";
export var headlinePost = "footer-module--headline-post--b391b";
export var inner = "footer-module--inner--0db1a";
export var link = "footer-module--link--2a0f7";
export var linkColumn = "footer-module--link-column--83006";
export var newsletter = "footer-module--newsletter--50b25";
export var paragraph = "footer-module--paragraph--3d678";
export var productLink = "footer-module--product-link--f1b14";
export var ratings = "footer-module--ratings--6287a";
export var socialMediaItem = "footer-module--social-media-item--48974";
export var socialMediaList = "footer-module--social-media-list--f1b44";